import { PersistContext } from "@/data/PersistProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import { LocalConfig } from "@/config";
import React, { useEffect } from "react";
import { Dialog } from "react-vant";
import style from "./style.less";

//签到coins数据
const coins_data1 = {
  check_days: [
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2500,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 3000,
    },
    {
      checked: false,
      coin: 500,
      condition_bet: 15000,
      silver: 0,
    },
    {
      checked: false,
      coin: 1000,
      condition_bet: 30000,
      silver: 0,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 5000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 6000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 7000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 8000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 9000,
    },
    {
      checked: false,
      coin: 2000,
      condition_bet: 45000,
      silver: 0,
    },
    {
      checked: false,
      coin: 2000,
      condition_bet: 60000,
      silver: 0,
    },
  ],
  today_checkable: true,
};

const coins_data2 = {
  check_days: [
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 2500,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 3000,
    },
    {
      checked: false,
      coin: 70000,
      condition_bet: 2100000,
      silver: 0,
    },
    {
      checked: false,
      coin: 140000,
      condition_bet: 4200000,
      silver: 0,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 5000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 6000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 7000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 8000,
    },
    {
      checked: false,
      coin: 0,
      condition_bet: 0,
      silver: 9000,
    },
    {
      checked: false,
      coin: 280000,
      condition_bet: 6300000,
      silver: 0,
    },
    {
      checked: false,
      coin: 280000,
      condition_bet: 8400000,
      silver: 0,
    },
  ],
  today_checkable: true,
};

const special_days_index = [5, 6, 12, 13]
const special_days_right_index = [5, 12]
const special_days_left_index = [6, 13]
const NewGetCoins = (props) => {
  let history = useEnhancedHistory();

  const { getPersist, setPersist, reloadUserInfo } = React.useContext(PersistContext);
  const { langText } = React.useContext(LanguageContext);

  const userInfo = getPersist("user_info");

  //是否展示签到所得
  const [pLogVisible, setPlogVisible] = React.useState(-1);

  //Get Coins弹框
  const [coinsData, setCoinsData] = React.useState(LocalConfig.locationKey == "UG2" ? coins_data2 : coins_data1);

  const [topSilver, setTopSilver] = React.useState(9000);
  const [totalSilver, setTotalSilver] = React.useState(45000);
  const [totalCoin, setTotalCoin] = React.useState(5500);
  
  //判断最后一次签到获取coins的index
  const [activeIndex, setActiveIndex] = React.useState(-1);

  const [bets, setBets] = React.useState(0);

  //获取签到coins数据
  const coins_data = () => {
    SendCMD("getCheckInNew", { token: userInfo.token }).then((res) => {
      if (res.check_in_data) {
        console.log("res.getCheckInNew-------------------------", res.check_in_data)
        setCoinsData(res.check_in_data);
        setBets(res.check_in_data.bets);
        let activeIndex = 0;
        let topSilver = 0;
        let totalSilver = 0;
        let totalCoin = 0;
        res.check_in_data.check_days.map((item, index) => {
          if(item.silver > topSilver) {
            topSilver = item.silver;
          }
          totalSilver += item.silver;
          totalCoin += item.coin;
          if (item.checked) {
            activeIndex = res.check_in_data.today_checkable ? index + 1 : index;
          }
        })
        activeIndex = activeIndex % res.check_in_data.check_days.length
        setActiveIndex(activeIndex);
        setTopSilver(topSilver);
        setTotalSilver(totalSilver);
        setTotalCoin(totalCoin);
      }
    });
  };

  //签到coins请求
  const coins_cmd = () => {
    if (coinsData.check_days[activeIndex].condition_bet > bets) {
      return
    }
    SendCMD("doCheckInNew", { token: userInfo.token }).then((res) => {
      console.log("doCheckInNew", res);
      if (res[0].check_success && res[0].check_in_data) {
        setCoinsData(res[0].check_in_data);
        reloadUserInfo();
      }

      res[0].check_in_data.check_days.map((item, index) => {
        if (item.checked) {
          setActiveIndex(index)
        }
      });

      //设置显示的p_log index
      setPlogVisible(activeIndex);
      setTimeout(() => {
        setPlogVisible(-1);
      }, 5000);
    });
  };

  //获取是否首冲
  useEffect(() => {
    if (userInfo) {
      coins_data();
    }
  }, [userInfo]);

  //点击Check In按钮事件
  const onCoinsClick = () => {
    //判断是否登录
    if (!userInfo) {
      //跳转到注册页面
      history.push(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}`));
      return;
    }

    //todo 判断是否可以点击
    if (!coinsData["today_checkable"]) {
      //跳转到抽奖页面
      history.push(ChannelRemind("./luckyDraw"));
      return;
    }
    
    //请求接口签到，并根据返回结果响应改变展示效果
    coins_cmd();
  };

  return (
    <Dialog
      closeable={true}
      closeOnClickOverlay={true}
      width={"85%"}
      visible={props.newCoinsDiaLogVisible != 0}
      showCancelButton={false}
      className={style.coinsDialog}
      showConfirmButton={false}
      onClose={() => {
        props.setNewCoinsDiaLogVisible(false);
      }}
    >
      <div class={style.firstCoinsDialog}>
        <div class={style.title_node}>
          <img class={style.title_img} src={require("@/assets/images/home/coins_title.png").default} />
        </div>
        <div class={style.firstCoinsSteps}>
          <div class={style.btntop}>
            {coinsData.check_days
              ? coinsData.check_days.map((item, index) => {
                  return (
                    <div key={index} class={
                      special_days_right_index.includes(index)
                      ? style.checkactivebox_special_right
                      : special_days_left_index.includes(index)
                      ? style.checkactivebox_special_left
                      : style.checkactivebox}
                      id={"index" + index}
                    >
                      <div class={style.c_l}>
                        {special_days_right_index.includes(index) || special_days_left_index.includes(index) ? (
                          <div class={style.c_l_text}>
                            <span>
                              {langText("task_title_3")}({ activeIndex == index ? (bets > item.condition_bet ? item.condition_bet/100 : bets/100) : index < activeIndex ? item.condition_bet/100 : 0 }/{ item.condition_bet/100 })
                            </span>
                          </div>
                        ) : (
                          <div class={style.c_l_num}>
                            <span>
                              +{item.silver / 100}
                            </span>
                          </div>
                        )}

                        <div class={special_days_index.includes(index) ? style.yuanbox_none : item.checked ? style.yuanbox_yes : style.yuanbox}>
                          {special_days_index.includes(index) && item.checked ? (
                            <span>
                              <img class={style.yuanbox_bg} src={require("@/assets/images/home/coins_di_2.png").default} />
                              <div class={style.keys_text}> +{item.coin / 100} {LocalConfig.currencyCode} </div>
                            </span>
                          ) : special_days_index.includes(index) ? (
                            <span>
                              <img class={style.yuanbox_bg} src={require("@/assets/images/home/coins_di.png").default} />
                              <div class={style.keys_text}> +{item.coin / 100} {LocalConfig.currencyCode} </div>
                            </span>
                          ) : (
                            <span></span>
                          )}
                          <div class={ style.yuanbox_rotate }>
                            {item.checked ? (
                              <sapn>
                                <img className={style.yuanbox_img} src={require("@/assets/images/home/coins_yes.png").default} style={{ width: "1rem" }} />
                              </sapn>
                            ) : (
                              <div>
                                <sapn className={style.yuanbox_day} style={special_days_index.includes(index) ? {color: "#BA974C"} : {color: "#035d3f"}}>DAY</sapn>
                                <br/>
                                <sapn
                                  className={index + 1 >= 10 ? style.yuanbox_num_double_digit : style.yuanbox_num_one_digit}
                                  style={special_days_index.includes(index) ? {color: "#634740"} : {color: "#035d3f"}}
                                >{index + 1}</sapn>
                              </div>
                            )}
                          </div>
                        </div>

                        <div class={style.tian}> Day </div>
                      </div>
                      <div>
                        <div
                          class={
                            index === 4 || index === 11
                            ? style.line_rotate_left
                            : index === 5 || index === 12
                            ? style.line_inverse
                            : index === coinsData.check_days.length - 1 || index === 6
                            ? style.none
                            : style.line
                          }
                          style={
                            item.checked && index < 7 && coinsData.check_days[index + 1] && coinsData.check_days[index + 1].checked
                            ? {backgroundColor: "#00FFCC"}
                            : coinsData.check_days[index + 1] && coinsData.check_days[index + 1].checked
                            ? {backgroundColor: "#00FFCC"}
                            :{backgroundColor: "#CAE7DC"}
                          }
                        ></div>
                        <div
                          class={index === 4 || index === 11 ? style.line_rotate_left_after : style.none}
                          style={
                            coinsData.check_days[index + 1] && coinsData.check_days[index + 1].checked
                            ? {backgroundColor: "#00FFCC"}
                            :{backgroundColor: "#CAE7DC"}
                          }
                        ></div>
                        <div
                          class={index === 7 ? style.line_rotate_right : style.none}
                          style={item.checked ? {backgroundColor: "#00FFCC"} : {backgroundColor: "#CAE7DC"}}
                        ></div>
                        <div
                          class={index === 7 ? style.line_rotate_right_after : style.none}
                          style={item.checked ? {backgroundColor: "#00FFCC"} : {backgroundColor: "#CAE7DC"}}
                        ></div>
                      </div>
                      <div
                        class={`${style.p_log} ${pLogVisible == index ? style.p_log_active : ""}`}
                        style={special_days_index.includes(index) ? {marginLeft:"35%"} : {}}
                      >
                        {""}
                        +{item.silver > 0 ? item.silver/100 : item.coin / 100} {item.silver > 0 ? "coins" : LocalConfig.currencyCode}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
        <div class={ coinsData && coinsData.check_days && coinsData.check_days[activeIndex] && coinsData.check_days[activeIndex].condition_bet > bets ? style.unFirstCoinsBtn : style.firstCoinsBtn} onClick={onCoinsClick}>
          <div class={style.firstCoinsDialogBtnText}>
            {!userInfo ? (
              getPersist("last_phone")?(<span>{langText("profile_btn_13")}</span>):(<span>REGISTER NOW</span>)
            ) : !coinsData.today_checkable ? (
              <span>{langText("coins_btn_2")}</span>
            ) : (
              <span>{langText("coins_btn_1")}</span>
            )}
          </div>
        </div>
        <div class={style.dashed_line} />
        <div class={style.coinsBottom}>
          <div class={style.coinsBottom_title}>{langText("coins_title_1")}</div>
          <div class={style.coinsBottom_content}>
            <span>{langText("coins_tips_12", {param1:topSilver/100})}.</span>
            <br />
            <span>{langText("coins_tips_22", {param1:totalSilver/100})}.</span>
            <br />
            <span>{langText("coins_tips_3")}</span>
            <br />
            <br />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default NewGetCoins;
